export enum TooltipDirection {
  bottom = 'bottom', // default
  right = 'right',
}
